/** The company attribute families a team objective may take its participants from. */
export const ObjectiveParticipantAttributeType = {
    DEPARTMENT: 'Department',
    JOB_TITLE: 'JobTitle',
    COMPANY_ADDRESS: 'CompanyAddress',
    EMPLOYEE_LEVEL: 'EmployeeLevel',
    MANAGER: 'Manager',
    CUSTOM_ATTRIBUTE: 'CustomAttribute',
} as const;

export type ObjectiveParticipantAttributeTypeValue =
    (typeof ObjectiveParticipantAttributeType)[keyof typeof ObjectiveParticipantAttributeType];
